import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { deleteCompanyLogo, uploadCompanyLogo } from 'services/CompanyService';

export const useUploadCompanyLogo = (companyId: number) =>
  useMutation(
    (file: Blob) => {
      const fileFormData = new FormData();
      fileFormData.append('logo', file);
      return uploadCompanyLogo(companyId, fileFormData);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANY]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error), {
          toastId: ReactMutationKeys.UPLOAD_COMPANY_LOGO,
        });
      },
      mutationKey: ReactMutationKeys.UPLOAD_COMPANY_LOGO,
    }
  );

export const useDeleteCompanyLogo = (companyId: number) => {
  const { t } = useTranslation();
  return useMutation(() => deleteCompanyLogo(companyId), {
    onSuccess: () => {
      toast.success(t('Successfully deleted logo'), {
        toastId: ReactMutationKeys.DELETE_COMPANY_LOGO,
      });
      queryClient.invalidateQueries(ReactQueryKeys.GET_COMPANY);
    },
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error), {
        toastId: ReactMutationKeys.DELETE_COMPANY_LOGO,
      });
    },
    mutationKey: ReactMutationKeys.DELETE_COMPANY_LOGO,
  });
};
